import React from "react";

export default function InputDropdown({
    name = "",
    value,
    label,
    labelstyle,
    options,
    styles,
    onChange,
    neededKey = '',
    selectName = '',
    isError = false,
    errMsg = ''
}) {

    return (
        <div>
            <label className={` ${labelstyle} text-[#555E61] font-semibold text-[11px]`}>
                {label}
            </label>
            {neededKey !== '' ?
                <select
                    name={name}
                    className={`${styles} border-[#979AA480] outline-none p-2.5 mt-5 w-full text-xs text-[#2B2B2B] rounded-md font-semibold`}
                    onChange={onChange}
                    value={value[neededKey]}
                >
                    <option key={0} value={JSON.stringify({ _id: '', addon: 'Select addon' })}>
                        Select
                    </option>
                    {options.map((item) => (
                        <option key={item._id} value={JSON.stringify({ _id: item._id, addon: item[neededKey] })}>
                            {item[neededKey]}
                        </option>
                    ))}
                </select>

                :
                <>
                <select
                    name={name}
                    className={`${styles} border-[#979AA480] outline-none p-2.5 mt-1 w-full  text-xs  text-[#2B2B2B] rounded-md font-semibold `}
                    onChange={onChange}
                    value={value}
                >
                    <option value={""}>
                        Select {selectName}
                    </option>
                    {options.map((item, index) => (
                        <option key={index} value={item.value}>
                            {item.label}
                        </option>
                    ))
                    }
                </select>
                {isError &&
                <p className="text-red-500 relative bottom-[-4px] text-[10px] mb-[-5px]">
                    {errMsg ? errMsg : label?.replaceAll(/[^a-zA-Z ]+/g, "")} Is Required Field
                </p>}
                </>
            }
        </div>
    )
}



